/* eslint-disable no-magic-numbers */
/*
 * File: helpers.js
 * Project: reports
 * Created Date: Monday July 30th 2018
 * Author: Austin Smith
 * -----
 * Last Modified: Friday, 5th October 2018 2:53:47 pm
 * Modified By: Austin Smith (austin.smith918@yahoo.com>)
 * -----
 * Copyright (c) 2018 Teaming
 */

/**
 * Helpers Functions
 */

// Ughh, really?
// eslint-disable-next-line no-extend-native
Number.prototype.format = function( fl = 2 ) {
	// eslint-disable-line no-extend-native
	let val = this.toFixed( fl );
	if ( fl === 0 ) {
		val = `${val}.`;
	}
	val = val.replace( /\d(?=(\d{3})+\.)/g, "$&," );
	if ( fl === 0 ) {
		return val.substr( 0, val.length - 1 );
	}
	return val;
};

/* eslint-disable no-mixed-operators */
export const easeInOutQuad = ( t, b, c, d ) => {
	t /= d / 2;
	if ( t < 1 ) {
		return ( c / 2 ) * t * t + b;
	}
	t--;
	return ( -c / 2 ) * ( t * ( t - 2 ) - 1 ) + b;
};
/* eslint-enable no-mixed-operators */

export const scrollTo = ( element, to, duration ) => {
	const start = element.scrollTop;
	const change = to - start;
	let currentTime = 0;
	const increment = 20;
	return new Promise( resolve => {
		const animateScroll = () => {
			currentTime += increment;
			element.scrollTop = easeInOutQuad( currentTime, start, change, duration );
			if ( currentTime < duration ) {
				return setTimeout( animateScroll, increment );
			}
			resolve();
		};
		animateScroll();
	} );
};

/* eslint-enable no-magic-numbers */



// WEBPACK FOOTER //
// ./src/helpers/helpers.js